'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateBar = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _timeAndDate = require('constants/time-and-date');

var _time = require('helpers/time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateBar = exports.DateBar = function (_Component) {
  (0, _inherits3.default)(DateBar, _Component);

  function DateBar(props) {
    (0, _classCallCheck3.default)(this, DateBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DateBar.__proto__ || (0, _getPrototypeOf2.default)(DateBar)).call(this, props));

    _this.state = {
      week: 0
    };
    _this.handlePrevWeekClick = _this.handlePrevWeekClick.bind(_this);
    _this.handleNextWeekClick = _this.handleNextWeekClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DateBar, [{
    key: 'handlePrevWeekClick',
    value: function handlePrevWeekClick() {
      if (this.state.week > 0) {
        this.setState({ week: this.state.week - 1 });
      }
    }
  }, {
    key: 'handleNextWeekClick',
    value: function handleNextWeekClick() {
      if (this.state.week < 1) {
        this.setState({ week: this.state.week + 1 });
      }
    }
  }, {
    key: 'datesToRender',
    value: function datesToRender() {
      var lastDateToShow = Date.now() + _timeAndDate.DAY_MS * (this.props.numberOfDaysToShow - 1);
      var now = new Date();
      var dates = [];
      for (var timestamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12).getTime(); timestamp <= lastDateToShow; timestamp += _timeAndDate.DAY_MS) {
        dates.push(new Date(timestamp));
      }
      return dates;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onDateClick = _props.onDateClick,
          selectedDate = _props.selectedDate;


      var sevenOrLessDays = this.props.numberOfDaysToShow <= 7;
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('schedule__datebar ' + this.props.extraClass, {
            'schedule__datebar--page2': this.state.week >= 1
          })
        },
        _react2.default.createElement('div', {
          onClick: this.handlePrevWeekClick,
          className: (0, _classnames2.default)('schedule__datebar__prev', {
            hidden: sevenOrLessDays,
            'schedule__datebar__prev--disabled': this.state.week === 0
          })
        }),
        _react2.default.createElement(
          'div',
          { className: 'schedule__datebar__scroll' },
          _react2.default.createElement(
            'ul',
            null,
            this.datesToRender().map(function (date) {
              return _react2.default.createElement(
                'li',
                {
                  key: date.getTime(),
                  onClick: function onClick() {
                    return onDateClick((0, _time.iso8601Date)(date));
                  },
                  className: (0, _classnames2.default)('schedule__datebar__date', {
                    selected: (0, _time.iso8601Date)(selectedDate) === (0, _time.iso8601Date)(date)
                  })
                },
                _react2.default.createElement(
                  'div',
                  { className: 'schedule__datebar__date__day' },
                  _timeAndDate.DAY_MAP_EN[date.getDay()]
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'schedule__datebar__date__date' },
                  date.getDate()
                )
              );
            })
          )
        ),
        _react2.default.createElement('div', {
          onClick: this.handleNextWeekClick,
          className: (0, _classnames2.default)('schedule__datebar__next', {
            hidden: sevenOrLessDays,
            'schedule__datebar__next--disabled': this.state.week >= 1
          })
        })
      );
    }
  }]);
  return DateBar;
}(_react.Component);

DateBar.propTypes = {
  extraClass: _propTypes2.default.string,
  selectedDate: _propTypes2.default.object.isRequired,
  onDateClick: _propTypes2.default.func.isRequired,
  numberOfDaysToShow: _propTypes2.default.number.isRequired
};